import { useEffect, useState } from "react";

// import logo from "assets/images/logo_new_1.svg";
import logo from "assets/images/logo_new_2.svg";
import Markdown from "markdown-to-jsx";
import styled from "styled-components";

import AdminApp from "components/apps/admin-app";
import GuestApp from "components/apps/guest-app";
import StudentApp from "components/apps/student-app";
import UniversityApp from "components/apps/university-app";
import Alerts from "components/modals/alerts";
import MapModal from "components/modals/map-modal";
import Modality from "components/modals/modality";
import OverlayedGallery from "components/tools/overlayed-gallery";

import UserApi from "api/user-api";

import { setUpInterceptors } from "services/api-service";
import ModalsService from "services/modals-service";

import { useStorageListener } from "hooks/useStorage";

import { ERoles } from "types/enums";
import ClubsAdminApp from "./clubs-admin-app";
import ClubsUniversityApp from "./clubs-university-app";

setUpInterceptors();

const RouterApp = () => {
    const role: ERoles = useStorageListener(`user.userRole`, ERoles.Guest);
    const initialized = useStorageListener(`initialized`) === true;
    const [warningVisible, setWarningVisible] = useState(localStorage.getItem(`first-visit-warning`) !== `false`);
    const uData = useStorageListener("user", {});
    console.log('router: uData = ', uData);
    let hasNoTelegram = (uData != undefined && (uData.telegramChannelsIds == undefined || uData.telegramChannelsIds.length == 0))
    // let shouldShowTelegramModal = ((hasNoTelegram == true) && (uData.isVip == true || uData.userRole == 'uni-admin'));
    let shouldShowTelegramModal = ((hasNoTelegram == true) && (uData.isVip == true || uData.userRole == 'uni-admin' || uData.userRole == 'clubs-uni-admin' || uData.userRole == 'clubs-admin'));
    // let shouldShowTelegramModal = true;

    useEffect(() => {
        UserApi.getCurrentUser();
    }, []);

    useEffect(() => {
        if (shouldShowTelegramModal == false){
            return;
        }
        ModalsService.showModality({
            title: `Внимание!`,
            description: (
                <Markdown>
                    {`Приветствуем Вас на платформе Программы молодежного и студенческого туризма Министерства науки и высшего образования Российской Федерации.
                <br />
                <br />
                Вам необходимо подключить телеграм-бот
                <br />
                <br />
                Для этого найдите в телеграме бота <b>@studtourism_bot</b>. Напишите боту команду <br/> "/login <b style="margin-right: 7px;" >ВАША-ПОЧТА</b> <b>ВАШ-ПАРОЛЬ</b>"
              `}
                </Markdown>
            ),
            cancelButton: {
                visible: false
            },
            confirmButton: {
                children: `Хорошо, спасибо`,
                onClick: () => {

                }
            }
        });
    }, [initialized, shouldShowTelegramModal]);



    useEffect(() => {
        console.log("uData = ", uData);
        console.log("shouldShowTelegramModal = ", shouldShowTelegramModal);

    }, [initialized, shouldShowTelegramModal]);


    if (!initialized) {
        return (
            <Loader>
                <MyLogo src={logo} />
            </Loader>
        );
    }

    // Проверка на блокировку и удаление пользователя
    const isUserBlocked = uData?.isBlocked === true;
    const isUserDeleted = uData?.isDeleted === true;

    return (
        <>
            <Alerts />
            <Modality />
            <OverlayedGallery />
            <MapModal />
            {isUserDeleted && (
                <BlockedOverlay>
                    <DeletedModal>
                        <DeletedTitle>Аккаунт удалён</DeletedTitle>
                        <DeletedText>
                            Ваш аккаунт был удалён.
                        </DeletedText>
                        <DeletedText>
                            Если вы считаете, что это ошибка, пожалуйста, свяжитесь с поддержкой проекта:
                        </DeletedText>
                        <BlockedContact>
                            <a href="mailto:support@mst22.ru">support@mst22.ru</a>
                        </BlockedContact>
                    </DeletedModal>
                </BlockedOverlay>
            )}
            {isUserBlocked && !isUserDeleted && (
                <BlockedOverlay>
                    <BlockedModal>
                        <BlockedIcon>
                            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12" cy="12" r="10" stroke="#E53935" strokeWidth="2"/>
                                <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" stroke="#E53935" strokeWidth="2"/>
                            </svg>
                        </BlockedIcon>
                        <BlockedTitle>Аккаунт заблокирован</BlockedTitle>
                        <BlockedText>
                            Ваш аккаунт был заблокирован администрацией платформы.
                        </BlockedText>
                        <BlockedText>
                            Если вы считаете, что это ошибка, пожалуйста, свяжитесь с поддержкой проекта:
                        </BlockedText>
                        <BlockedContact>
                            <a href="mailto:support@mst22.ru">support@mst22.ru</a>
                        </BlockedContact>
                    </BlockedModal>
                </BlockedOverlay>
            )}
            {{
                [ERoles.University]: <UniversityApp />,
                [ERoles.ClubsUniAdmin]: <ClubsUniversityApp />,
                [ERoles.Student]: <StudentApp />,
                [ERoles.Guest]: <GuestApp />,
                [ERoles.Admin]: <AdminApp />,
                [ERoles.ClubsAdmin]: <ClubsAdminApp />
            }?.[role] ?? <GuestApp />}
        </>
    );
};

// const openFirstVisitModality = (callback: Function = () => {}) => {
//     ModalsService.showModality({
//         title: `Уважаемый посетитель!`,
//         description: (
//             <Markdown>
//                 {`Приветствуем тебя на платформе Программы молодежного и студенческого туризма Министерства науки и высшего образования Российской Федерации.
//                 <br />
//                 <br />
//                 В этом году к Программе присоединились более 190 ВУЗов, из более 100 городов нашей необъятной Родины. Сейчас информация на платформе в
//                 стадии наполнения, но ты можешь отслеживать изменения ежедневно.
//                 <br />
//                 <br />
//                 И да, не волнуйся и не переживай - старт бронирования не ранее 15 мая, а сами поездки в этом году начнутся с 1 июня 2022
//                 года.
//                 <br />
//                 <br />
//                 К моменту твоего выбора все будет готово!`}
//             </Markdown>
//         ),
//         cancelButton: {
//             visible: false,
//         },
//         confirmButton: {
//             children: `Перейти к сайту`,
//             onClick: () => {
//                 localStorage.setItem(`first-visit-warning`, `false`);
//                 callback();
//             },
//         },
//     });
// };

const Loader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 1000;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: white;
`;

const MyLogo = styled.img`
  height: 220px;
`;

const BlockedOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
`;

const BlockedModal = styled.div`
    background: white;
    border-radius: 16px;
    padding: 40px;
    max-width: 450px;
    width: 90%;
    text-align: center;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
`;

const BlockedIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 24px;
`;

const BlockedTitle = styled.h2`
    margin: 0 0 16px 0;
    font-size: 24px;
    color: #E53935;
`;

const BlockedText = styled.p`
    margin: 0 0 12px 0;
    font-size: 15px;
    color: #555;
    line-height: 1.5;
`;

const BlockedContact = styled.div`
    margin-top: 20px;
    padding: 16px;
    background: #F5F5F5;
    border-radius: 8px;

    a {
        color: #1976D2;
        font-size: 16px;
        font-weight: 600;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }
`;

const DeletedModal = styled.div`
    background: white;
    border-radius: 16px;
    padding: 40px;
    max-width: 450px;
    width: 90%;
    text-align: center;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
`;

const DeletedTitle = styled.h2`
    margin: 0 0 16px 0;
    font-size: 24px;
    color: #333;
`;

const DeletedText = styled.p`
    margin: 0 0 12px 0;
    font-size: 15px;
    color: #555;
    line-height: 1.5;
`;

export default RouterApp;
